import { mods } from '@approvalmax/theme';
import { Flex } from '@approvalmax/ui/src/components';
import { StyledMods } from '@styled-kit/mods';
import { WarningLevel } from 'modules/request';
import { font, uTransparentLink } from 'modules/styles';
import ExchangeRate from 'pages/requestList/components/ExchangeRate/ExchangeRate';
import styled from 'styled-components';

export const FooterOnlySection = styled.div`
    padding: 0 60px;
`;

export const Footer = styled.div`
    display: flex;
`;

export const FooterLeftBlock = styled.div`
    flex: 1;
`;

export const StyledExchangeRate = styled(ExchangeRate)`
    margin-bottom: 30px;
    ${font(11, '#565656', 'semibold')}
`;

export const ExchangeRateCurrency = styled.span`
    display: inline;
    color: #000;
`;

export const ExternalUrl = styled.div`
    margin-top: 30px;
    display: flex;
    align-items: center;
`;

export const ExternalUrlLink = styled.div`
    display: flex;
    align-items: center;
+    ${uTransparentLink}
`;

export const ExternalUrlLinkText = styled.span`
    margin-left: 10px;
    ${font(13, '#000', 'standard')}
`;

export const FooterTotalBlock = styled.div`
    display: flex;
    flex-flow: column;
    align-items: flex-end;
`;

export const FooterAmountsTaxType = styled.div`
    margin-bottom: 15px;
    ${font(11, '#777d81', 'semibold')}
`;

export const FooterExchangeRate = styled.div`
    ${font(11, '#565656', 'semibold')}
`;

export const FooterExchangeRateCurrency = styled.span`
    display: inline;
    color: #000;
`;

export const PriceIndicator = styled.div<StyledMods<{ warningLevel: WarningLevel }>>`
    margin-left: 3px;
    border-radius: 50%;
    width: 5px;
    height: 5px;

    ${mods('warningLevel', WarningLevel.Yellow)`
        background: #ffe688;
    `}

    ${mods('warningLevel', WarningLevel.Orange)`
        background: #f0984f;
    `}

    ${mods('warningLevel', WarningLevel.Red)`
        background: #cb4e30;
    `}

    ${mods('warningLevel', WarningLevel.Black)`
        background: #000;
    `}
`;

export const NoWrapCell = styled.span`
    white-space: nowrap;
`;

export const UnitPriceCell = styled(NoWrapCell)`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const DescriptionCell = styled.div`
    word-break: break-word;
    white-space: pre-line;
`;

export const ReorderableContent = styled(Flex)<StyledMods<{ ordered: boolean; applyTaxAfterDiscount: boolean }>>`
    ${mods('ordered', true)`
        ${mods('applyTaxAfterDiscount', false)`
            & > :nth-child(1) {
                order: 1;
            }
        `}
        
        ${mods('applyTaxAfterDiscount', true)`
            & > :nth-child(1) {
                order: -1;
            }
        `}
        
        & > :nth-child(2) {
                order: 2;
            }
    `}
`;
